import './App.css';
import Card from './components/Card/Card';

function App() {
  return (
    <div className="App">
      <Card />
    </div>
  );
}

export default App;
